import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';

import {
  FormGroup,
  ControlLabel,
} from 'react-bootstrap';

import AllUsersListEnhanced from './AllUsersListEnhanced';
import TimesheetTerminatedUsersCheckboxEnhanced from './TimesheetTerminatedUsersCheckboxEnhanced';
import DistrictFilter from '../../fields/DistrictFilter';
import DepartmentFilter from '../../fields/DepartmentFilter';
import { getDepartmentId, getDistrictId } from '../selectors';
import { setDepartment, setDistrict } from '../actions';

const propTypes = exact({
  districtId: PropTypes.number,
  departmentId: PropTypes.number,
  setDistrictAction: PropTypes.func.isRequired,
  setDepartmentAction: PropTypes.func.isRequired,
});


const TimesheetFilteringPanel = (props) => {
  const { districtId, departmentId, setDistrictAction, setDepartmentAction } = props;

  return (
    <React.Fragment>
      <FormGroup>
        <ControlLabel className="control-label">
          District:
        </ControlLabel>
        <DistrictFilter
          name="Field District"
          value={{ id: districtId }}
          onChange={setDistrictAction}
        />
      </FormGroup>
      <FormGroup>
        <ControlLabel className="control-label">
          Department:
        </ControlLabel>
        <DepartmentFilter
          name="Department"
          value={{ id: departmentId }}
          onChange={setDepartmentAction}
        />
      </FormGroup>
      <FormGroup>
        <TimesheetTerminatedUsersCheckboxEnhanced />
      </FormGroup>
      <AllUsersListEnhanced />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    districtId: getDistrictId(state),
    departmentId: getDepartmentId(state),
  };
};

const mapDispatchToProps = {
  setDistrictAction: setDistrict,
  setDepartmentAction: setDepartment,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

TimesheetFilteringPanel.propTypes = propTypes;


export default withRedux(TimesheetFilteringPanel);
